import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Alert from '@cloudscape-design/components/alert';
import Select from '@cloudscape-design/components/select';
import '../css/home.css';

const SEARCH_OPTIONS = [
  { value: 'payment', label: 'Payment', placeholder: 'Enter End-to-End ID, e.g. DASAVFAR7YBWZBC' },
];

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState(SEARCH_OPTIONS[0]);
  const [query, setQuery] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSearch = () => {
    const q = query.trim();
    if (!q) {
      setError('Please enter a search query.');
      return;
    }
    setError(null);
    if (searchType.value === 'payment') {
      navigate(`/payment?q=${encodeURIComponent(q)}`);
    }
  };

  return (
    <div className="home-search">
      <SpaceBetween size="l">
        <div>
          <div className="home-search__title">Track a Payment</div>
          <div className="home-search__subtitle">Search by payment ID or file name</div>
        </div>

        <div className="home-search__bar">
          <div className="home-search__bar-type">
            <Select
              selectedOption={searchType}
              onChange={({ detail }) => { setSearchType(detail.selectedOption as typeof searchType); setError(null); }}
              options={SEARCH_OPTIONS}
              expandToViewport
            />
          </div>
          <div className="home-search__bar-input">
            <Input
              value={query}
              onChange={({ detail }) => { setQuery(detail.value); setError(null); }}
              placeholder={searchType.placeholder}
              onKeyDown={({ detail }) => { if (detail.key === 'Enter') handleSearch(); }}
              inputMode="search"
            />
          </div>
          <Button variant="primary" onClick={handleSearch} iconName="search">Search</Button>
        </div>

        {error && <Alert type="error">{error}</Alert>}
      </SpaceBetween>
    </div>
  );
};

export default Home;
